<app-coupons *ngIf="english"></app-coupons>
<app-coupons-hindi *ngIf="hindi"></app-coupons-hindi>